import React , {useState} from 'react'
import {  updateDoc  , collection, getFirestore, onSnapshot , doc} from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
const firebaseConfig = {
  apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
  authDomain: "to-do-list-app-7aa20.firebaseapp.com",
  projectId: "to-do-list-app-7aa20",
  storageBucket: "to-do-list-app-7aa20.appspot.com",
  messagingSenderId: "388979404562",
  appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
};
initializeApp(firebaseConfig)

// init services
const db = getFirestore()
// collection Ref
const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)



function Finished(targets) {
  // console.log(targets.targets)
  const [showControls , setShowControls] = useState(false)
  
  const handleUnFinished = f => {
    console.log(f.inProgress , f.deleted)
    
    const docRef = doc(colRef , `${f.id}` )

    updateDoc(docRef , {
      inProgress : true ,
      finished : false
    });

    
    Swal.fire({
      position: 'center',
      imageUrl: 'https://c.tenor.com/EIOUntPW4jIAAAAd/hassan-hosni-egyptian-comic-actor.gif',
      imageWidth: 400,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      showCloseButton : true
    })
  }

  return (
    <div className="notes finishedEle">
      <div className="container">
        <div className="content">
          <div className="top alert alert-success">
            <h1>Compeleted Tasks</h1>
            {targets.targets.filter(f => f.finished === true).length !== 0 && (
            <button className="controlSet" onClick={()=> setShowControls(!showControls)}>
              <img src="https://cdn-icons-png.flaticon.com/512/627/627495.png" alt="" title='control button' />
            </button>
            )}
          </div>
          {targets.targets.filter(f => f.finished === true).length === 0 && 
            <div className="alerting unfinished">
              <div className="alert alert-secondary">
                <h3>No Task has finished yet!!</h3>
                <img src="https://c.tenor.com/2VUoFxkI0MAAAAAC/adel-imam-el-sefara-fel-emara.gif" alt="not finished" />
                <button>
                  <Link to='/progress' >
                    GO finish One
                  </Link>
                </button>
              </div>
            </div>
          }
          <div className="bottom">
            {targets.targets.filter(f => f.finished === true).map(p => (
              <div key={p.id} className="tab">
                <h3 dir='auto'>{p.Target}</h3>
                <p dir='auto'>{p.Description}</p>
                {showControls === true && (
                  <div className="options finished-opt" >
                    <div className="cont">
                      <button onClick={()=> handleUnFinished(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/5110/5110294.png" alt="Wait" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Finished